module.exports = __webpack_public_path__ + "static/img/y7.0a5efed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y7.jpg
// module id = uWZ0
// module chunks = 1